'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var core = require('@material-ui/core');
var getThemeProp = require('../../utils/getThemeProp.js');

var DialogPrimaryButton = styled__default(core.Button)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  font-size: 16px;\n  color: ", ";\n  font-weight: 500;\n"], ["\n  font-size: 16px;\n  color: ", ";\n  font-weight: 500;\n"])), getThemeProp('palette.text.hint', 'blue'));
var templateObject_1;

module.exports = DialogPrimaryButton;
